import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiService } from '../services/api'
import { LocalStorageService } from '../services/localStorage'

interface MarkEpisodeParams {
  episodeId: number
  showId: number
  type?: 0 | 1 | 2
  episodeName?: string
  season?: number
  episode?: number
}

export function useMarkEpisode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      episodeId,
      showId,
      type = 0,
      episodeName,
      season,
      episode,
    }: MarkEpisodeParams) => {
      // Save to localStorage first (always works)
      if (type === 0) {
        // Only save watched episodes locally
        LocalStorageService.addWatchedEpisode(episodeId, showId, episodeName, season, episode)
      }

      // Try API call (might fail)
      try {
        await apiService.markEpisode(episodeId, type)
      } catch (error) {
        console.warn('API call failed, but episode saved locally:', error)
        // Don't throw error - localStorage save was successful
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['marked'] })
      queryClient.invalidateQueries({ queryKey: ['watchedShows'] })
    },
  })
}

export function useUnmarkEpisode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (episodeId: number) => {
      // Remove from localStorage first (always works)
      LocalStorageService.removeWatchedEpisode(episodeId)

      // Try API call (might fail)
      try {
        await apiService.unmarkEpisode(episodeId)
      } catch (error) {
        console.warn('API call failed, but episode unmarked locally:', error)
        // Don't throw error - localStorage removal was successful
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['marked'] })
      queryClient.invalidateQueries({ queryKey: ['watchedShows'] })
    },
  })
}
